/* global globalThis */

class DataLayerHelper {
  // Must be run from client
  static pushEvent(event, data = {}) {
    if (typeof globalThis === 'undefined') {
      return;
    }

    globalThis.dataLayer = globalThis.dataLayer || [];
    globalThis.dataLayer.push({ event, ...data });
  }
}

export default DataLayerHelper;
